const readTicker = (row) =>
  String(row?.ticker ?? row?.supplier_id ?? row?.supplierId ?? '').trim();

const mapSupplierBreakdown = (row) => {
  const ticker = readTicker(row);
  return {
  ticker,
  supplierId: ticker,
  supplierName: row?.supplier_name ?? row?.supplierName ?? '',
  newsRiskScore: row?.news_risk_score ?? row?.newsRiskScore ?? null,
  pathExposureScore: row?.path_exposure_score ?? row?.pathExposureScore ?? null,
  geoPoliticalScore: row?.geo_political_score ?? row?.geoPoliticalScore ?? null,
  logisticsScore: row?.logistics_score ?? row?.logisticsScore ?? null,
  weightedRiskScore: row?.weighted_risk_score ?? row?.weightedRiskScore ?? null,
};
};

const mapPathImpact = (row) => {
  const ticker = readTicker(row);
  const startTicker =
    String(row?.start_ticker ?? row?.start_company_id ?? row?.startCompanyId ?? '').trim();
  const endTicker =
    String(row?.end_ticker ?? row?.end_company_id ?? row?.endCompanyId ?? '').trim();
  return {
  routeId: row?.route_id ?? row?.routeId ?? '',
  ticker,
  supplierId: ticker,
  startTicker,
  endTicker,
  startCompanyId: startTicker,
  endCompanyId: endTicker,
  impactScore: row?.impact_score ?? row?.impactScore ?? null,
  explanation: row?.explanation ?? '',
};
};

const mapGeopoliticalRisk = (row) => ({
  geographyId: row?.geography_id ?? row?.geographyId ?? '',
  isoCode: row?.iso_code ?? row?.isoCode ?? '',
  name: row?.name ?? '',
  score: row?.score ?? null,
  reason: row?.reason ?? '',
});

export const mapTenantRiskAnalysisResult = (data) => {
  if (!data || typeof data !== 'object') {
    return null;
  }

  const supplierBreakdown = data.supplier_breakdown ?? data.supplierBreakdown ?? [];
  const pathImpacts = data.path_impacts ?? data.pathImpacts ?? [];
  const geopoliticalBreakdown = data.geopolitical_breakdown ?? data.geopoliticalBreakdown ?? [];
  const contributingLogisticsNodes =
    data.contributing_logistics_nodes ?? data.contributingLogisticsNodes ?? [];
  const selectedSupplierIds = data.selected_supplier_ids ?? data.selectedSupplierIds ?? [];
  const notes = data.notes ?? [];

  return {
    analysisId: data.analysis_id ?? data.analysisId ?? '',
    userId: data.user_id ?? data.userId ?? '',
    analysisDate: data.analysis_date ?? data.analysisDate ?? '',
    tenantOverallRiskScore: data.tenant_overall_risk_score ?? data.tenantOverallRiskScore ?? null,
    supplierBreakdown: Array.isArray(supplierBreakdown)
      ? supplierBreakdown.map(mapSupplierBreakdown)
      : [],
    pathImpacts: Array.isArray(pathImpacts) ? pathImpacts.map(mapPathImpact) : [],
    geopoliticalBreakdown: Array.isArray(geopoliticalBreakdown)
      ? geopoliticalBreakdown.map(mapGeopoliticalRisk)
      : [],
    contributingLogisticsNodes: Array.isArray(contributingLogisticsNodes)
      ? contributingLogisticsNodes
      : [],
    selectedSupplierIds: Array.isArray(selectedSupplierIds) ? selectedSupplierIds : [],
    notes: Array.isArray(notes) ? notes : [],
  };
};

export const buildTenantRiskAnalysisRequest = (userId, options = {}) => {
  const rawIds = options.selectedSupplierIds ?? options.selected_supplier_ids ?? [];
  const selected_supplier_ids = (Array.isArray(rawIds) ? rawIds : [])
    .map((id) => String(id || '').trim().toUpperCase())
    .filter(Boolean);

  return {
  user_id: userId,
  selected_supplier_ids,
  include_watchlist_suppliers:
    options.includeWatchlistSuppliers ?? options.include_watchlist_suppliers ?? true,
  news_weight: options.newsWeight ?? options.news_weight ?? 0.5,
  path_weight: options.pathWeight ?? options.path_weight ?? 0.2,
  geo_political_weight: options.geoPoliticalWeight ?? options.geo_political_weight ?? 0.2,
  logistics_weight: options.logisticsWeight ?? options.logistics_weight ?? 0.1,
};
};
